export default __webpack_public_path__ + "static/img/homepage-foreground-nov-2024.fd582af.png";